
















































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({})
export default class SurfaceActivitySvg extends Vue {
  @Prop() colorScheme!: 'light' | 'dark'
  get color(): string {
    return this.colorScheme === 'light' ? '#FFFFFF' : '#000000'
  }
}
